import propertyOrNull from 'contest/utils/property-or-null';
import user from '../models/user';

export default {
    create,
    defaultProperties,
    fromJSON,
};

function create(properties) {
    return Object.assign({}, defaultProperties(), properties);
}

function defaultProperties() {
    return {
        designId: null,
        entryId: null,
        size: null,
        width: null,
        height: null,
        createdAt: new Date().toString(),
        showUrl: null,
        previewUrl: null,
        creator: null,
        activeUserRole: null,
        permission: {},
        status: '',
        links: {
            self: null,
            delete: null,
            comments: null,
            awardDesign: null,
            addToFolio: null,
            handover: null,
            markAsReadComments: null,
            markAsSeen: null,
            report: null,
            sketches: null,
            updateSketches: null,
            facebook: null,
            twitter: null,
            pinterest: null,
            shortURL: null,
        },
    };
}

// Translate from HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    const data = {
        designId: propertyOrNull(json, 'id'),
        entryId: propertyOrNull(json, 'entry_id'),
        showUrl: propertyOrNull(json, 'entry_url'),
        previewUrl: propertyOrNull(json, 'original_image_url'),
        status: propertyOrNull(json, 'status'),
        creator: user.fromJSON(json._embedded.user),
        activeUserRole: json.activeUserRole,
        permission: json._embedded.permission || {},
        prizeAward: json._embedded.prizeAward || null,
        stockDeclarations: json._embedded.stockDeclarations || [],
        generativeAiDeclaration: json._embedded.generativeAiDeclaration || null,
        payments: json._embedded.payments || {},
        rating: json.rating || 0,
        isEliminated: json.is_eliminated,
        isWinner: json.is_winner,
        isWithdrawn: json.is_withdrawn,
        isDeleted: json.is_deleted,
        isSeen: json.is_seen,
        createdAt: json.timeCreatedString,
        links: {
            self: propertyOrNull(json._links.self, 'href'),
            delete: propertyOrNull(json._links.delete, 'href'), // FIXME: do we need this?
            comments: propertyOrNull(json._links.comments, 'href'),
            createComment: propertyOrNull(json._links.createComment, 'href'),
            awardDesign: propertyOrNull(json._links.awardDesign, 'href'),
            addToFolio: propertyOrNull(json._links.addToFolio, 'href'),
            handover: propertyOrNull(json._links.handover, 'href'),
            handoverMessages: propertyOrNull(json._links.handoverMessages, 'href'),
            markAsReadComments: propertyOrNull(json._links.markAsReadComments, 'href'),
            markAsSeen: propertyOrNull(json._links.markAsSeen, 'href'),
            report: propertyOrNull(json._links.report, 'href'),
            lastSeenTime: propertyOrNull(json._links.lastSeenTime, 'href'),
            sketches: propertyOrNull(json._links.sketches, 'href'),
            updateSketches: propertyOrNull(json._links.updateSketches, 'href'),
            facebook: propertyOrNull(json._links.facebook, 'href'),
            twitter: propertyOrNull(json._links.twitter, 'href'),
            pinterest: propertyOrNull(json._links.pinterest, 'href'),
            shortURL: propertyOrNull(json._links.shortURL, 'href'),
        },
    };

    const keys = [
        'size', // FIXME: we don't have this...
        'width',
        'height',
    ];

    keys.forEach((k) => (data[k] = propertyOrNull(json, k)));
    return data;
}



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/models/design.js